export default {
  fr: {
    neighborhood: "aucun groupe | un groupe | {count} groupes",
    borough: "aucun quartier | un quartier | {count} quartiers",
  },
};
